import { Theme, alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const MEDIA_OVERLAY_BLUR = 'blur(3px)';

const CONTROL_SIZE = 38;
const OUTLINED_BACKGROUND_OPACITY = 0.3;
const OUTLINED_HOVER_BACKGROUND_OPACITY = 0;
const OUTLINED_BORDER_OPACITY = 0.5;

export const getMediaOverlayBorder = (theme: Theme) =>
  `0.5px solid ${alpha(theme.palette.common.white, OUTLINED_BORDER_OPACITY)}`;

export const useMediaOverlayIconButtonStyles = makeStyles()((theme) => ({
  control: {
    flexShrink: 0,
    width: CONTROL_SIZE,
    height: CONTROL_SIZE,
    '&&, &&:hover': {
      color: theme.palette.common.white,
    },
  },
  outlined: {
    border: getMediaOverlayBorder(theme),
    backdropFilter: MEDIA_OVERLAY_BLUR,
    '&&': {
      backgroundColor: alpha(theme.palette.common.black, OUTLINED_BACKGROUND_OPACITY),
    },
    '&&:hover': {
      backgroundColor: alpha(theme.palette.common.black, OUTLINED_HOVER_BACKGROUND_OPACITY),
    },
  },
}));
